import { Button, Form, TextField } from '@gyym/ui'
import { zodResolver } from '@hookform/resolvers/zod'
import React from 'react'
import { useForm, type UseFormSetError } from 'react-hook-form'
import { z } from 'zod'

import { EMAIL_REGEX } from '@/lib/form'

export const schema = z.object({
  email: z
    .string()
    .min(1, { message: 'メールアドレスを入力してください' })
    .regex(EMAIL_REGEX, { message: '有効なメールアドレスではありません' }),
})

export type FormValues = z.infer<typeof schema>

export type SubmitContext = {
  setError: UseFormSetError<FormValues>
}

export interface PasswordRecoveryFormProps {
  /**
   * Initial form values (e.g. prefill the logged-in user's email)
   */
  values?: Partial<FormValues>

  /**
   * Submit handler
   */
  onSubmit: (values: FormValues, ctx: SubmitContext) => void
}

export const PasswordRecoveryForm = ({
  values,
  onSubmit,
}: PasswordRecoveryFormProps) => {
  const {
    register,
    setError,
    handleSubmit,
    formState: { errors, isValid, isSubmitting },
  } = useForm<FormValues>({
    mode: 'onTouched',
    resolver: zodResolver(schema),
    defaultValues: values,
  })

  const onSubmitHandler = React.useCallback(
    (values: FormValues) => onSubmit(values, { setError }),
    [onSubmit, setError],
  )

  return (
    <Form gap={4} onSubmit={handleSubmit(onSubmitHandler)}>
      <TextField
        label="メールアドレス"
        placeholder="メールアドレスを入力"
        {...register('email')}
        errorMessages={errors.email?.message}
        autoComplete="email"
      />

      <div className="mt-6 flex w-full self-center tablet:max-w-[240px]">
        <Button
          type="submit"
          variant="brand"
          size="lg"
          fullWidth
          loading={isSubmitting}
          disabled={!isValid}
        >
          メールを送信
        </Button>
      </div>
    </Form>
  )
}
